import { createCommon } from '@/public/fetch/crypto';
import utils from '@/public/utils';
import { getTokenObj } from '@/widget';
// const timetemp = require('@/assets/js/random/index')
let sign = {
    appVersion: '8.0.0'
};
/**
 * 请求参数拦截器
 *
 */
export function requestInterceptor(config) {
    // 这里可以对request进行一些自定义配置
    Object.assign(sign, createCommon());
    // 请求头添加token
    const tokenObj = getTokenObj();
    if (tokenObj.version) {
        sign.appVersion = tokenObj.version;
    }
    const token = tokenObj.token;
    config.headers.Authorization = token || '';
    if (!token) {
        config.headers.userId = Number(tokenObj.userId) || 0;
        config.headers.nl = 1;
    }
    // get 请求
    if (config.method === 'get') {
        let con = Object.assign({}, sign, config.params);
        config.params = con;
    }
    // 表单 data为json对象
    if (config.isFormData) {
        config.transformRequest = [
            function (data) {
                // 对 data 进行任意转换处理
                let obj = Object.assign({}, data, sign);
                return utils.queryStringify(obj);
            }
        ];
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }
    // post 接口 url上携带签名校验 post(url[, data[, config]])
    // if (config.isNeedSign) {
    //   config.url = `${config.url}?${utils.queryStringify(createCommon())}`
    // }
    if (config.method?.toLowerCase() === 'post' && !config.isFormData) {
        config.url = `${config.url}?${utils.queryStringify(sign)}`;
    }
    return config;
}
